<template>
  <div>
    <template v-for="(list,index) in this.menuList">
      <div class="menuTree" :class="{'active':index ==checkindex }" :key="list.id" v-if="list.isVisible == '0'" @click="changeColor(index)">
        <el-submenu v-if="list.children.length>0&& list.menuType =='目录'" :key="list.id" :index="String(list.id)">
          <template slot="title" style="padding-left:10px">
            <i v-if="list.level =='2'" class="el-icon-menu"></i>
            <span slot="title">{{ list.menuName}}</span>
          </template>
          <Menu :menuList="list.children"></Menu>
        </el-submenu>
        <router-link v-else tag="span" :class="'level_' +list.level" :to="list.menuUrl" :key="list.menuUrl">
          <el-menu-item :index="String(list.id)" :class="'level_' +list.level">
            <span>{{list.menuName}}</span>
          </el-menu-item>
        </router-link>
      </div>
    </template>
  </div>
</template>
<style>
  .el-menu--collapse span,
  .el-menu--collapse i.el-submenu__icon-arrow {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }
  .router-link-active>li{
    color: #409EFF;
  }
  .menuTree {
    background-color: #06497D;
  }
  .menuTree span{
    color: #fff;
  }
  .el-submenu__title:hover{
    background-color: #0a83da;
  }
  .el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: #003664;
  }
  .active {
    background: #003664;
  }
</style>
<script>
	import * as util from "@/assets/js/util";

  export default {
		name: 'Menu',//模板名称
		data() {
			return {
        checkindex: 0 // 初始化第一个栏块高亮
      }
		},
		beforeMount() {
      this.changeColor(0);
      this.$router.push({
        path: `${this.menuList[0].menuUrl}`
      });
		},
    methods:{
      // sendMessage(menu){
      //   //通过vuex将数据存储在store中
      //   this.$store.commit('mutationSelectTags', menu)
      //   // this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addTab(menuName,menuId);
      // },
      changeColor(index){
        this.checkindex = index
      }
    },
		props: ['menuList']

	}
</script>
